import React, { useMemo, useState, useRef } from 'react';
import TableLayout from '../../molecules/TableLayout';
import Table from '../../molecules/Table';
import Field from '../Field';
import Form from '../../molecules/Form/Form';
import { useForm } from '../../molecules/Form';
import dummyImg from '../../../assets/avatar-2.svg';
import Button from '../../molecules/Button';
import { MdSort } from 'react-icons/md';
import CenterModal from '../../molecules/Modal/CenterModal';
import EnrichMessageModal from '../EnrichMessageModal';
import Step4 from './Step4';
import Step2 from './Step2';
import LeadsData from './LeadsData';
import Step1 from './Step1';
import { LeadsStepWrap, MappingContacts } from './CreateCompaign.styles';
import campaignService from '../../../services/campaignService';
import usePersistedSearchQuery from '../../../hooks/usePersistedSearchQuery';
import { useLocation } from 'react-router-dom';
import { formatDate } from '../../../helpers/common.js';
import { handleDebouncedSearch, handleSearchNow } from '../../../helpers/common.js';

const StepLeads = ({ NextStep, setData, setStep, data, step, isEdit }) => {
  const [form] = useForm();
  const location = useLocation();
  const campaignStatus = location?.state?.status;
  const campaignType = location?.state?.campaign_type;
  const debounceRef = useRef(null);
  const [enrichmentModal, setEnrichmentModal] = useState(false);
  const [companyDetailsModal, setCompanyDetailsModal] = useState(false);
  const [isInLeadsStep, setIsInLeadsStep] = useState(false);
  const [csvInfo, setCsvInfo] = useState(null);
  const [fetch, setFetch] = useState(false);

  const [searchQuery, setSearchQuery] = usePersistedSearchQuery({
    page: 1,
    itemsPerPage: 10,
    startDate: '',
    endDate: '',
    searchText: '',
    start_time: '',
    end_time: '',
    status: 'all',
    orderBy: 'newest_first',
    sortField: '',
    sortDirection: 'asc',
    trigger: 0,
  });
  const leadsSearchQuery = useMemo(
    () => ({
      id: data?.step1?.list_id,
      page: searchQuery.page,
      itemsPerPage: searchQuery.itemsPerPage,
      searchText: searchQuery.searchText,
      trigger: searchQuery.trigger,
      getAll: false,
      campaignId: isEdit ? location?.state?.campaign_id : data?.step1?.list_id ? data?.step2?.campaignId : undefined,
    }),
    [
      data?.step1?.list_id,
      data?.step2?.campaignId,
      isEdit,
      location?.state?.campaign_id,
      searchQuery.page,
      searchQuery.itemsPerPage,
      searchQuery.searchText,
      searchQuery.trigger,
    ],
  );
  const [openLeadsModal, setOpenLeadsModal] = useState(data?.step1?.list_id || false);
  const [addLeadsDataTab, setAddLeadsDataTab] = useState((data?.step1?.list_id && 'leadsData') || 'leads');

  const { campaign_leads_data, campaign_leads_loading } = campaignService.GetCampaignLeads(leadsSearchQuery, fetch);
  const handleSort = field => {
    setSearchQuery(prev => {
      const newDirection = prev.sortField === field && prev.sortDirection === 'asc' ? 'desc' : 'asc';
      return { ...prev, sortField: field, sortDirection: newDirection, page: 1 };
    });
  };

  const Status = data => {
    switch (data.first_name) {
      case data.first_name:
        return <div className="badge success">Connected</div>;
      case 'failed':
        return <div className="badge danger">{data?.status}</div>;
      case 'running':
        return <div className="badge running">{data?.status}</div>;
      case 'draft':
        return <div className="badge draft ">{data?.status}</div>;
      case 'insufficient_credits':
        return <div className="badge draft">{data?.status}</div>;
      default:
        return <div className="badge neutral right">Unknown</div>;
    }
  };

  const renderSortableHeader = (label, field) => {
    const isActive = searchQuery.sortField === field;
    const direction = searchQuery.sortDirection;

    // Only allow sorting on specific fields
    const isSortable = ['status', 'created_date'].includes(field);

    if (!isSortable) return <div>{label}</div>;

    return (
      <div
        className="sortable-header"
        onClick={() => handleSort(field)}
        style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
        {label}
        <MdSort
          className={`icon ${isActive ? 'active' : ''}`}
          style={{
            transform: isActive && direction === 'desc' ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.2s ease',
            color: 'rgba(0, 0, 0, 0.25)',
          }}
        />
      </div>
    );
  };

  const columnNamess = useMemo(() => {
    return [
      <Field type="checkbox" name="select_all" noMargin label="Name" />,
      // renderSortableHeader('Status', 'status'),
      // renderSortableHeader('Created Date', 'created_date'),
      'Status',
      'Created date',
      'Company',
      'Position',
      'Email',
    ];
  }, [searchQuery]);

  const { product_rows, totalCount } = useMemo(() => {
    const isUsingMappedRows = !campaign_leads_data?.data?.items && data?.step2?.mappedRows;

    let allLeadsData = campaign_leads_data?.data?.items || data?.step2?.mappedRows || [];

    if (isUsingMappedRows && searchQuery.searchText) {
      const search = searchQuery.searchText.toLowerCase();

      allLeadsData = allLeadsData.filter(row =>
        [row.first_name].filter(Boolean).some(value => value.toString().toLowerCase().includes(search)),
      );
    }

    let leadsData = allLeadsData;
    if (isUsingMappedRows && allLeadsData.length > 0) {
      const startIndex = (searchQuery.page - 1) * searchQuery.itemsPerPage;
      const endIndex = startIndex + searchQuery.itemsPerPage;
      leadsData = allLeadsData.slice(startIndex, endIndex);
    }

    if (allLeadsData?.length > 0) {
      return {
        product_rows: leadsData?.map((row, idx) => ({
          cells: [
            <div className="comp-td-col lead-detail">
              <Field
                type="checkbox"
                noMargin
                name={row.first_name || row.campaign_id}
                label={
                  <div className="flex-content">
                    <div className="avatar-wrap">
                      <img
                        src={row.profile_photo || dummyImg}
                        alt="Lead Avatar"
                        className="avatar"
                        onError={e => (e.currentTarget.src = dummyImg)}
                      />
                    </div>
                    <div className="text-wrap">
                      <span className="campaign-name">
                        {row.first_name || row.First_Name || row.name || row.Name || 'Lead'}
                      </span>
                    </div>
                  </div>
                }
              />
            </div>,
            Status(row),
            formatDate(row?.user_lead_created_at || data?.step2?.user_lead_created_at),
            <div className="comp-td-text">{row?.company_name || '-'}</div>,
            <div className="comp-td-text">{row?.title || '-'}</div>,
            <div className="comp-td-text">{row?.email || '-'}</div>,
          ],
        })),
        totalCount: isUsingMappedRows ? allLeadsData.length : campaign_leads_data?.data?.totalItems || 0,
      };
    }

    return {
      product_rows: [],
      totalCount: 0,
    };
  }, [data, campaign_leads_data, searchQuery.page, searchQuery.itemsPerPage, searchQuery.searchText]);

  function handleNext() {
    if (data?.step1?.list_id && campaignType === "basic" || campaignType === "basic") {
      setStep(6);
    } else {
      setStep(11);
    }
    // else {
    //   setEnrichmentModal(true);
    // }
  }

  return (
    <>
      {/* <CenterModal open={enrichmentModal} setOpen={setEnrichmentModal} width="430" noHead>
        <EnrichMessageModal
          NextStep={NextStep}
          setStep={setStep}
          setData={setData}
          setEnrichmentModal={setEnrichmentModal}
          setCompanyDetailsModal={setCompanyDetailsModal}
        />
      </CenterModal>
      <CenterModal open={companyDetailsModal} setOpen={setCompanyDetailsModal} padding="0" width="975" noHead isCloseAble={false}>
        <Step4
          NextStep={NextStep}
          setStep={setStep}
          data={data}
          setData={setData}
          setCompanyDetailsModal={setCompanyDetailsModal}
        />
      </CenterModal> */}
      <CenterModal open={openLeadsModal} setOpen={setOpenLeadsModal} width={975} noHead padding="0" isCloseAble={false}>
        <MappingContacts $isLeadsStep={addLeadsDataTab === 'leads'}>
          {!data?.step1?.list_id && (
            <div className="tab-btns">
              <span className={`btn ${addLeadsDataTab === 'leads' ? 'active' : ''}`}>Upload Leads</span>
              <span className={`btn ${addLeadsDataTab === 'mapping' ? 'active' : ''}`}>Data Mapping</span>
              <span className={`btn ${addLeadsDataTab === 'leadsData' ? 'active' : ''}`}>Import Contacts</span>
            </div>
          )}
          <div className="edit-content-wrap">
            {addLeadsDataTab === 'leads' ? (
              <Step1
                setData={setData}
                data={data}
                NextStep={NextStep}
                step={step}
                setStep={setStep}
                addLeadsDataTab={addLeadsDataTab}
                isInLeadsStep={isInLeadsStep}
                setAddLeadsDataTab={setAddLeadsDataTab}
                setOpenLeadsModal={setOpenLeadsModal}
                csvInfo={csvInfo}
                setCsvInfo={setCsvInfo}
              />
            ) : addLeadsDataTab === 'mapping' ? (
              <Step2
                setData={setData}
                data={data}
                NextStep={NextStep}
                step={step}
                addLeadsDataTab={addLeadsDataTab}
                setAddLeadsDataTab={setAddLeadsDataTab}
                isInLeadsStep={isInLeadsStep}
              />
            ) : (
              addLeadsDataTab === 'leadsData' && (
                <LeadsData
                  setOpenLeadsModal={setOpenLeadsModal}
                  isInLeadsStep={isInLeadsStep}
                  setAddLeadsDataTab={setAddLeadsDataTab}
                  csvInfo={csvInfo}
                  data={data}
                  setData={setData}
                  setStep={setStep}
                // leadsData={leads_data?.data?.items}
                />
              )
            )}
          </div>
        </MappingContacts>
      </CenterModal>
      <LeadsStepWrap>
        <Form form={form} onSubmit={values => handleSearchNow(values.search, setSearchQuery)}>
          <div className="filter-wrap">
            <div className="form-search">
              <Form.Item
                colorBg
                inputSm
                noMargin
                label=""
                type="search"
                rounded
                name="search"
                placeholder="Search Lead"
                onChange={e => handleDebouncedSearch(e.target.value, form, debounceRef, setSearchQuery)}>
                <Field />
              </Form.Item>
              <Button variant="darkBlue" rounded width="150px" type="submit">
                Search
              </Button>
            </div>
            {isEdit && campaignStatus !== 'completed' && (
              <Button
                onClick={() => {
                  setIsInLeadsStep(true);
                  setOpenLeadsModal(true);
                }}
                variant="secondary"
                rounded
                width="150px">
                Add leads
              </Button>
            )}
          </div>
        </Form>
        <TableLayout
          onChangeFilters={filters => {
            setSearchQuery(_ => ({
              ..._,
              ...filters,
            }));
            setFetch(prev => !prev);
          }}
          noStyle
          currentPage={searchQuery?.page}
          pageSize={searchQuery?.itemsPerPage}
          totalCount={totalCount}
          isNextBtn={isEdit && campaign_leads_data?.isEnrichment !== null ? false : true}
          innerHeight="calc(100vh - 292px)"
          NextBtnClick={() => handleNext()}
        >
          <Table rowsData={product_rows} columnNames={columnNamess} noPadding profilePicture loading={campaign_leads_loading} />
        </TableLayout>
      </LeadsStepWrap>
    </>
  );
};

export default StepLeads;
